"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _components = require("components");

var _PageTitle = require("@quixeltools/quixel-ui-library/dist/components/common/website/PageTitle");

var _PageTitle2 = _interopRequireDefault(_PageTitle);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _Link = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Link");

var _Link2 = _interopRequireDefault(_Link);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const docxLink = 'https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelMegascansToS_MAY172018.docx';
var pdfLink = "https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelMegascansToSApril172019.pdf";
// const docxLinkEULA ='https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelFreeAssetsEULAOCT302017.doc'
var pdfLinkEULA = "https://d3uwib8iif8w1p.cloudfront.net/docs/QuixelFreeAssetsEULAOCT302017.pdf";
var cloudfrontThumbs = function cloudfrontThumbs(path) {
  return "https://cdn.quixel.com/quixel/thumbs/" + path;
};

var tos = (0, _glamor.css)({
  margin: "0 auto",
  maxWidth: "957px",
  width: "70%",
  marginBottom: "9rem"
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  marginTop: "9rem"
}));

var para = (0, _glamor.css)({
  color: _css.pallets.gray_text,
  fontSize: (0, _css.unitRem)(0.875),
  lineHeight: (0, _css.unitRem)(1.2),
  marginTop: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(1),
  "& strong": {
    fontWeight: 700
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: (0, _css.unitRem)(0.7)
}));

var content = (0, _glamor.css)({
  "& h1": {
    color: _css.pallets.gray_text,
    fontSize: (0, _css.unitRem)(1.4),
    lineHeight: (0, _css.unitRem)(1.2),
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  },
  "& p": {
    color: _css.pallets.gray_text,
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  },
  "& ol": {
    counterReset: "item"
  },
  "& ul": {
    listStyleType: "circle",
    marginLeft: "2rem",
    color: _css.pallets.gray_text
  },
  "& li": {
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),

    ":before": {
      position: "relative",
      color: _css.pallets.gray_text,
      // content: 'counters(item, ".")". "',
      // counterIncrement: 'item',
      fontSize: (0, _css.unitRem)(0.875),
      lineHeight: (0, _css.unitRem)(1.2),
      // left: '-2.2rem',
      // top: '3.3rem',

      "& strong": {
        fontWeight: 600
      }
    }
  },
  "& strong": {
    fontWeight: 600
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  "& h1": {
    fontSize: (0, _css.unitRem)(1.1)
  },
  "& p": {
    fontSize: (0, _css.unitRem)(0.7)
  },
  "& li": {
    ":before": {
      fontSize: (0, _css.unitRem)(0.7)
    }
  }
}));
var _link = (0, _glamor.css)({
  transition: "color 0.2s ease-in-out",
  ":hover": {
    color: "#fff!important"
  }
});
var ol = (0, _glamor.css)({
  counterReset: "item",
  "& ul": {
    counterReset: "none"
  },
  "& ul li:before": {
    content: "none",
    counterIncrement: "none"
  }
});

var li = (0, _glamor.css)({
  ":before": {
    position: "relative",
    color: _css.pallets.gray_text,
    content: 'counters(item, ".")". "',
    counterIncrement: "item",
    fontSize: (0, _css.unitRem)(0.875),
    lineHeight: (0, _css.unitRem)(1.2),
    left: "-3.2rem",
    top: "3.3rem",

    "& strong": {
      fontWeight: 600
    }
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  ":before": {
    fontSize: (0, _css.unitRem)(0.7)
  }
}));

var _hr = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3),
  marginBottom: (0, _css.unitRem)(3)
});
var privacy = (0, _glamor.css)({
  margin: "0 auto",
  maxWidth: "70%"
});

var button = (0, _glamor.css)({
  marginRight: (0, _css.unitRem)(1)
});

var refund = (0, _glamor.css)({
  margin: (0, _css.unitRem)(5) + " auto",
  marginTop: 0,
  maxWidth: "74%"
});

var strong = (0, _glamor.css)({
  fontWeight: 600
});

var downloadButtons = (0, _glamor.css)({
  margin: (0, _css.unitRem)(2) + " 0",
  textAlign: "left"
});

var contactUs = (0, _glamor.css)({
  margin: "0 auto",
  marginBottom: (0, _css.unitRem)(5),
  textAlign: "center",
  maxWidth: "74%"
});
var _col = (0, _glamor.css)({
  paddingLeft: "1.1rem",
  flexBasis: "33.3333%",
  border: "1px " + _css.pallets.gray_text + " solid",
  color: "" + _css.pallets.gray_text,
  "& p": {
    wordBreak: "break-word"
  }
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  paddingLeft: "0.7rem",
  "& p": {
    fontSize: (0, _css.unitRem)(0.01),
    lineHeight: (0, _css.unitRem)(0.7),
    "& ul": {
      fontSize: (0, _css.unitRem)(0.01),
      lineHeight: (0, _css.unitRem)(0.7),
      marginLeft: 7,
      "& li": {
        fontSize: (0, _css.unitRem)(0.01),
        lineHeight: (0, _css.unitRem)(0.7)
      }
    }
  },
  "& ul": {
    fontSize: (0, _css.unitRem)(0.01),
    lineHeight: (0, _css.unitRem)(0.7),
    marginLeft: 7,
    "& li": {
      fontSize: (0, _css.unitRem)(0.01),
      lineHeight: (0, _css.unitRem)(0.7)
    }
  }
}));
var heading = (0, _glamor.css)({
  textAlign: "center",
  flexBasis: "33.3333%",
  border: "1px " + _css.pallets.gray_text + " solid",
  color: "" + _css.pallets.gray_text
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  "& p": {
    fontSize: (0, _css.unitRem)(0.01)
  }
}));

var ToS = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ToS, _Component);

  function ToS(props) {
    (0, _classCallCheck3.default)(this, ToS);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ToS.__proto__ || (0, _getPrototypeOf2.default)(ToS)).call(this, props));

    _this.onTosQuery = _this.onTosQuery.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ToS, [{
    key: "onTosQuery",
    value: function onTosQuery() {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: "Have a query about our ToS?",
        description: "We would be happy to provide answers regarding our Terms of Service. Leave us a note and we will get back to you soon.",
        tag: "TermsOfService",
        initialValues: { name: "", email: "", subject: "", comment: "" }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var hash = this.props.location.hash;
      if (hash && hash.length) {
        if (hash.indexOf("#") == 0) {
          hash = hash.slice(1);
        }
        setTimeout(function () {
          var elem = document.getElementById(hash);
          var yAxis = elem.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo(0, yAxis);
        }, 90);
      }
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: " - Legal",
          documentImage: cloudfrontThumbs("page-thumb-legal.jpg"),
          documentDescription: "Before you use a free product, apply for a revenue share product, or purchase a subscription product from Quixel, you may review the terms and conditions of Quixel’s limited warranty; including limitations and exclusions."
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.SiteHeaderGap, null),
          _react2.default.createElement(
            "section",
            { id: "assets-license", className: tos },
            _react2.default.createElement(
              "p",
              {
                className: (0, _glamor.css)({
                  fontSize: "1rem",
                  fontWeight: "700",
                  marginTop: "1.5rem",
                  marginBottom: "1.5rem",
                  color: "#6F6F6F",
                  textTransform: "uppercase",
                  "& a": {
                    fontWeight: "700"
                  }
                })
              },
              "Our privacy policy has been updated and is included",
              " ",
              _react2.default.createElement(
                _Link2.default,
                { href: "/terms#privacy-policy", className: _link },
                "below"
              ),
              " ",
              "to reflect the processing carried out by Epic Games."
            ),
            _react2.default.createElement(
              "div",
              {
                className: (0, _glamor.css)(_hr, { marginTop: "6px", marginBottom: "30px" })
              },
              _react2.default.createElement(_Hr2.default, null)
            ),
            _react2.default.createElement(_PageTitle2.default, {
              align: "left",
              dateTop: true,
              title: "QUIXEL END-USER LICENSE AGREEMENT",
              subTitle: "NOV 12TH 2019"
            }),
            _react2.default.createElement(
              "div",
              { className: content },
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "This End-User License Agreement (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Agreement"
                ),
                "\u201D or \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "EULA"
                ),
                "\u201D) describes Your rights and responsibilities when using the Quixel Services and Licensed Assets. This Agreement applies to all users of the Services (collectively or individually, \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "You"
                ),
                "\u201D)."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "If your primary residence (or primary place of business, if you are a legal entity like a corporation or an academic institution) is in the United States of America, your agreement is with Epic Games, Inc.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "If it is not in the United States of America, your agreement is with Epic Games International S.\xE0 r.l., acting through its Swiss branch.\xA0"
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "1. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "ACCEPTANCE"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p4" },
                "This EULA is a legal agreement between You and Epic and governs Your use of the Services. The purpose of this EULA is to allow You to use the Services provided by Epic. This EULA is made effective beginning on the date on which You first access or otherwise use the Services (the \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Start Date"
                ),
                "\u201D). For additional information regarding how we handle information You transmit to us please visit the Quixel Privacy Policy (",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/terms#privacy-policy" },
                  "www.quixel.com/terms#privacy-policy"
                ),
                "). By using the Services, you acknowledge that You have read the Privacy Policy."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "IF YOU ARE ENTERING INTO THIS AGREEMENT ON BEHALF OF A COMPANY OR OTHER LEGAL ENTITY, YOU REPRESENT THAT YOU HAVE THE AUTHORITY TO BIND SUCH ENTITY TO THESE TERMS AND CONDITIONS, IN WHICH CASE THE TERMS \u201CYOU\u201D, \u201CYOUR\u201D, ETC. SHALL REFER TO SUCH ENTITY, ITS AFFILIATES AND USERS ASSOCIATED WITH IT. IF YOU DO NOT HAVE SUCH AUTHORITY, YOU MAY NOT ACCEPT THIS AGREEMENT AND MAY NOT USE THE SERVICES."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "BY ACCESSING OR OTHERWISE USING THE SERVICES, YOU AGREE TO ABIDE BY THE TERMS OF THIS EULA, AND A LEGALLY BINDING AGREEMENT IS CREATED BETWEEN EPIC AND YOU. YOUR USE OF THE SERVICES CONSTITUTES YOUR ACCEPTANCE OF THE EULA. IF YOU DO NOT AGREE TO THESE TERMS, DO NOT ACCESS, INSTALL, COPY, OR USE THE SERVICES."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "2. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "ACCOUNTS AND REGISTRATION"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "You must register an account via the Quixel website (",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/" },
                  "www.quixel.com"
                ),
                "), or on other permitted websites or platforms, to access the Services. The account must be registered to only one (1) individual physical person (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Registered User"
                ),
                "\u201D); provided, however, that accounts registered and owned by a corporation or other legal entity may be shared solely for the purposes of practicing such entity\u2019s rights and obligations under this Agreement. You may not, under any circumstances, whether intentionally, or through negligence or inaction, allow or enable others to access Your account, unless specifically permitted in writing by Epic. You are not permitted to transfer Your account, any Licensed Assets, or Points to another person or entity, unless specifically permitted in writing by Epic."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "When registering an account, You must provide Epic with a valid e-mail address and password which will be registered by Epic. You acknowledge and agree that You will (a) provide true, accurate, current, and complete information as requested when registering an account and (b) maintain and update this registration information to keep it true, accurate, current, and complete. You are solely responsible for maintaining the confidentiality of Your account and password and for restricting access to any computer or device that You use for accessing the Services. You are responsible for all activities that occur under Your account. Epic reserves the right to refuse the Services, suspend or terminate accounts, remove or edit content, delete assets, or cancel orders in its reasonable discretion if You provide registration information which is false, inaccurate, not current, or incomplete. Epic may share Your registration information with its partners, affiliates, and third parties solely as necessary to operate Epic\u2019s businesses (e.g., process orders and payments etc.)."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "3. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "THE SERVICES"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "The \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Services"
                ),
                "\u201D consist of the following software services: (i) a library (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Megascans Library"
                ),
                "\u201D) of 2D and 3D scanned objects and materials (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Megascans Assets"
                ),
                "\u201D), (ii) a software editing tool (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Mixer"
                ),
                "\u201D) for mixing Megascans Assets and generating Customer Assets, and (iii) software (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Bridge"
                ),
                "\u201D) providing an application program interface for integrating Megascans Assets and Customer Assets with game engines, renderers and other digital content creation tools, in each case, that Epic makes available to You under this Agreement. You may utilize Megascans Assets with any software tool, including Mixer, and all resulting new content that incorporates Megascans Assets or is a derivative work of Megascans Assets will constitute a \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Customer Asset"
                ),
                "\u201D subject to this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "4. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "LICENSES AND RESTRICTIONS"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "4.1 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "License Plans"
                ),
                ". Please contact",
                " ",
                _react2.default.createElement(
                  "span",
                  { className: "s1" },
                  _react2.default.createElement(
                    _Link2.default,
                    {
                      className: _link,
                      target: "_blank",
                      href: "mailto:legal@quixel.se"
                    },
                    "legal@quixel.se"
                  )
                ),
                " ",
                "if You have questions regarding which license You qualify for."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.1.1 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Personal License"
                ),
                ". The Personal License is for individuals generating less than $100,000 USD in annual gross revenue; provided, however, that individuals who start on the Personal License plan will not be considered to be in breach of this limitation and will not be required to upgrade their license unless and until they generate more than $100,000 annual gross revenue for two consecutive years. The Personal License allows for single seat use by hobbyists, freelancers, or individuals who work alone. Sharing Your Personal License account information, assets, or tools with others is strictly prohibited.",
                " "
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.1.2 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Indie License"
                ),
                ". The Indie License is for entities within a corporate group that generates an aggregate of less than $2,000,000 USD per year in annual gross revenue and funds raised and that is not affiliated with or funded by a publisher owned or controlled studio. The Indie License grants usage rights for a single entity. Sharing Your Indie License account information, assets, or tools with others outside Your business is strictly prohibited, except to permit subcontractors to practice your license subject to Section 4.3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.1.3 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Pro License"
                ),
                ". The Pro License is for entities within a corporate group that generates an aggregate of less than $20,000,000 USD per year in annual gross revenue and funds raised and that is not affiliated with or funded by a publisher owned or controlled studio. The Pro License grants usage rights for a single entity. Sharing Your Pro License account information, assets, or tools with others outside Your business is strictly prohibited, except to permit subcontractors to practice your license subject to Section 4.3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.1.4 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Studio License"
                ),
                ". If You do not qualify for a license listed under subsections 4.1.1 \u2013 4.1.3 above, You may not use the Services under this Agreement but may use the Services under a separate Quixel Studio License. Please contact",
                " ",
                _react2.default.createElement(
                  "span",
                  { className: "s1" },
                  _react2.default.createElement(
                    _Link2.default,
                    {
                      className: _link,
                      target: "_blank",
                      href: "mailto:legal@quixel.se"
                    },
                    "legal@quixel.se"
                  )
                ),
                " ",
                "for more information."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.1.5 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Megascans Free Asset License"
                ),
                ".",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "This section shall only apply to the extent you are not already licensed to use Megascans Free Assets under Sections 4.1.1 \u2013 4.1.4 above (in which case the terms of the applicable license shall apply to your use of Megascans Free Assets). Quixel hereby grants you, a non-exclusive, non-transferable right to use the Services to download, use, and modify Megascans Free Assets solely for your internal evaluation purposes. You may not or allow others to sell, license, or otherwise commercially use or exploit any products or services containing Megascans Free Assets.",
                " "
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.1.6 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Twinmotion License"
                ),
                ".",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "If you hold a license to Twinmotion under the Twinmotion EULA, Epic hereby grants you a non-exclusive, revocable, non-transferable right to use the Services to download, use, and modify Megascans Assets and import Licensed Assets into your Twinmotion projects for the purpose of visualizing such assets within Twinmotion and exporting images and videos as permitted under the Twinmotion EULA.",
                " "
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "4.2 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "License"
                ),
                ". Subject to Your payment of applicable Fees and Your continued compliance with this Agreement, Epic grants You a limited, non-exclusive, revocable, non-sublicensable, non-transferable license to (i) use the Services for the purpose of adding Megascans Assets to Your Products, (ii) use the Services for the purpose of creating Customer Assets for inclusion in Your Products, and (iii) distribute Licensed Assets solely as incorporated as an inseparable part of Your Products. All rights granted to You are granted by license only and not by sale. No license or other rights will be created hereunder by implication, estoppel, or otherwise. The licenses granted in this Section 4.2 shall not apply to the licenses described in Sections 4.1.5 \u2013 4.1.6.",
                " "
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "4.3",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Subcontractors"
                ),
                ". If you have been granted an Indie or Pro License, You may grant subcontractors and affiliates access to the Services solely to practice your rights granted in this Section 4 on Your behalf. You are directly and primarily responsible for the acts and omissions of such subcontractors and affiliates under this Agreement and applicable laws as Your own acts and omissions.\xA0"
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "4.4 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "License"
                ),
                " ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Restrictions. "
                ),
                "The Licensed Assets are intended solely for use in Your Products."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.4.1",
                " ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "No Right to Create or Sell Licensed Assets On Stand-Alone Basis"
                ),
                ". Licensed Assets may not be sold, leased, licensed or otherwise provided to third parties on a \u201Cstand-alone\u201D basis, i.e., Your Products must reasonably add value beyond the value of the Licensed Assets."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.4.2 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Content Creation Software Restriction"
                ),
                ".",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "Unless You have received Epic\u2019s prior written consent, You may not:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p6" },
                "(i) bundle, incorporate, or distribute Licensed Assets in or with any digital content creation software (including, without limitation, tools for the creation of user generated content) that is monetized or used to generate revenue, directly or indirectly, by You or any third party; or"
              ),
              _react2.default.createElement(
                "p",
                { className: "p6" },
                "(ii) except as permitted in Section 4.3, permit third parties to use or access the Licensed Assets to modify or extend your Product (including, without limitation, via digital content creation software such as a mod-kit) if such use or access is monetized or used to generate revenue, directly or indirectly, by You or any third party."
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "4.4.3 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Other Restrictions"
                ),
                ". You expressly agree that You shall not: (i) attempt to reverse engineer, decompile, translate, or disassemble the Services, Licensed Assets, or related software or materials; (ii) rent, lease, or transfer the Services, Licensed Assets, or related software or materials; (iii) use the Services, Licensed Assets, or related software or materials for any illegal purpose; (iv) use the Services, Licensed Assets, or related software or materials in any manner which violates the rights of a third party, including without limitation intellectual property Epic; (v) use the Services, Licensed Assets, or related software or materials for any middleware, content, or other software or service that competes with the Services in whole or in part; (vi) use the Services, Licensed Assets, or related software or materials to develop, enhance or facilitate any AI, neural network developments or improvements; (vii) mass download and/or use the Services, Licensed Assets, or related software or materials, (viii) use the Services, Licensed Assets, or related software or materials in any manner that breaches this Agreement; (ix) take any action that imposes an unreasonable or disproportionately large load on the Services or related systems or servers, or (x) use the Services or any information accessible through the Services, to bypass the login architecture or create or provide any other means through which the Services may be accessed and/or used by others."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "Please contact",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                " ",
                "if you have any questions regarding the license restrictions in this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "4.5 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Audit"
                ),
                ". You agree to keep accurate books and records related to your use of the Services and Licensed Assets, including without limitation financial documents confirming your eligibility for any particular license plan.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "Epic may conduct reasonable audits of those books and records.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "Audits will be conducted during business hours on reasonable prior notice to you. If you have exceeded the scope of Your license, You will be responsible for the cost of the audit, and You will need a new license plan to continue using the Services.\xA0"
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "5. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "FEES AND POINTS"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "The fees for the Services (\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Fees"
                ),
                "\u201D) and applicable subscription periods are stated in the Services and/or on the",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/" },
                  "www.quixel.com"
                ),
                " ",
                "website. Payment of the Fees provides You with Points. \u201D",
                " ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Points"
                ),
                " \u201D are digital resources which can be redeemed for Megascans Assets available in the Megascans Library. Points do not constitute a personal property right and have no value outside the Services. You may also purchase additional Points to be used in the Services. Point fees are stated in the Services and/or on the",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/" },
                  "www.quixel.com"
                ),
                " ",
                "website. Purchased Points are non-refundable."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "ALL FEES ARE PAYABLE IN ADVANCE AND ARE NOT REFUNDABLE IN WHOLE OR IN PART, UNLESS STATED OTHERWISE BY EPIC IN WRITING."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "6. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "PAYMENT"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "Please note that once You have ordered and paid for the Services, You have started consuming the Services, and You cannot disclaim the ordered Services, paid Points or demand return payment. You agree to fully pay any and all Fees for the Services purchased through Your account with any form of payment method accepted by Epic. You are responsible for providing Epic with valid credit card information to secure payments. Epic reserves the right to cancel any Services ordered if any funds are insufficient, the credit card information You provide is not valid etc. Payments may be processed in cooperation with third party payment service providers."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "When You open an account, You authorize Epic or its partners to charge Your credit card, or use other forms of payment methods accepted by Epic, for the Fees in accordance with the payment terms. Epic and its partners reserve the right to change the Fees, the Point costs, the payment terms, or any availability of the Services at any time without notice; provided, however, such changes will not affect the Fees paid or Points used and payment terms for any products and services already purchased and paid for in full. You are responsible for reviewing the EULA or the Services for any changes in the Fees, Points cost, or payment terms. If a change is unacceptable to You, You may, as Your sole and exclusive remedy, terminate and close Your account as described in the termination section below. You are responsible for paying all applicable taxes (including those taxes and tariffs Epic or its partners are not required to collect) and for all hardware, software, Internet service costs and other costs You incur to access the Services."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "Epic may offer premium services. You are informed of the fees, charges and payment terms during the registration or purchase process. Epic may also offer other services, either for one-time fees or for recurring fees. The current fees and payment terms may be viewed on the Quixel website (",
                _react2.default.createElement(
                  "span",
                  { className: "s1" },
                  _react2.default.createElement(
                    _Link2.default,
                    { className: _link, href: "/" },
                    "www.quixel.com"
                  )
                ),
                ") or in other locations as informed to You by Epic and/or partners. Epic and partners may amend the fees and payment terms at any time. All fees are in U.S. Dollars unless otherwise specified. If Your purchases etc. are subject to any type of applicable taxes, then Epic and partners may also charge You for any such taxes."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "7. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "INTELLECTUAL PROPERTY RIGHTS"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "Except for the Megascans Assets incorporated therein, any intellectual property right and title to Customer Assets shall where applicable become Your intellectual property. You grant Epic an irrevocable, sublicensable, perpetual, worldwide, royalty-free right and license to use Customer Assets that have been publicly released solely for marketing and promotional purposes. You represent and warrant that You have all necessary rights to grant such licenses to Epic. You represent and warrant that You own the content You create or otherwise have all licenses, rights, consents, and permissions necessary for the inclusion of such content within the Services and use of materials in the manner contemplated by Epic and this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "Epic owns all rights, titles, copyrights, and other intellectual property rights and interests, including but not limited to all trademarks, service marks, and trade names etc. in the Services, Megascans Assets, related software and material, any documentation, and any copies thereof and retains all such rights and any other products and services. Except as expressly granted in this Agreement, no license, right or interest in any Epic or Quixel patent, trademark, copyright, trade name or service mark is granted hereunder. The Services are licensed, not sold. Except as expressly authorized by Epic, You agree not to sell, license, distribute, copy, modify, publicly perform or display, transmit, publish, edit, adapt, create derivative works or competing products or services from, or otherwise make unauthorized use of the Services, Licensed Assets, or other Materials. You agree not to assert against Epic any claim, action or proceeding for infringement of any patents, patent rights or other intellectual property rights. You are not required to provide any ideas, feedback or suggestions regarding the Services or any of Epic\u2019s products or services (collectively, \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Feedback"
                ),
                "\u201D) to Epic. To the extent You do provide any Feedback to Epic, You agree to assign and hereby do assign all right, title and interest in and to such Feedback to Epic and acknowledge that Epic may freely use, reproduce, modify, distribute, make, have made, sell, offer for sale, import and otherwise exploit in any manner such Feedback without payment of any royalties or other consideration to You."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "8. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "TERM AND TERMINATION"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "The term of this EULA and the license granted herein shall begin on the Start Date, as defined above, and shall be ongoing until terminated. You can terminate Your license at any time by registering such termination on the Quixel webpage,",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/" },
                  "www.quixel.com"
                ),
                ". Epic may terminate the Agreement by providing written notice if you materially breach any provision of this Agreement and the breach is not curable or, if it is curable, you fail to cure the breach within thirty (30) days of notice of the breach from Epic.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "Without limiting the foregoing, your failure to make any payment due under this Agreement or breach of any restriction under the Epic Licenses constitutes a material breach of this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "Termination of the EULA will result in Your account being deactivated and Your license being terminated. Upon termination of this agreement You shall (i) immediately cease use of the Services and (ii) destroy all copies of the Services, plug-ins etc. within Your possession and any item containing confidential information, and all of its component parts, within Your possession, unless Your use is otherwise specifically permitted by Epic. You will not receive a refund of prepaid Fees or purchased Points. Sections 4.4, 4.5, 6-13 shall survive expiration or termination of this agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "9. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "DISCLAIMER AND LIMITATION OF LIABILITY"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "EPIC MAKES NO REPRESENTATION OR WARRANTY AS TO THE COMPLETENESS OR ACCURACY OF THE SERVICES OR INFORMATION CONTAINED THEREIN, NOR DOES IT REPRESENT OR WARRANT THAT THE SERVICES WILL BE AVAILABLE AT ALL TIMES OR THAT IT WILL FUNCTION IN A MANNER OR AS FAST OR EFFICIENT AS YOU MAY EXPECT OR DESIRE. THE INFORMATION CONTAINED IN THE SERVICES MAY BE INCOMPLETE, MAY CONTAIN ERRORS, OR BECOME OUT OF DATE AT ANY TIME. THE SERVICES ARE PROVIDED ON AN \u201CAS IS\u201D BASIS WITHOUT ANY EXPRESS WARRANTIES. EPIC SHALL HAVE NO OBLIGATION TO CORRECT ERRORS IN, PROVIDE UPDATES FOR, OR OTHERWISE SUPPORT THE SERVICES. EPIC RESERVES THE RIGHT TO ADD, MODIFY, OR DELETE ITS SERVICES AT ANY TIME. EPIC DOES NOT GIVE ANY EXPRESS, IMPLIED, OR STATUTORY REPRESENTATIONS, WARRANTIES, GUARANTEES, OR CONDITIONS. EPIC ALSO EXCLUDES ALL IMPLIED WARRANTIES, INCLUDING ANY WARRANTY OF MERCHANTABILITY, TITLE, DURABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. NOTHING IN THIS AGREEMENT SHALL AFFECT THOSE STATUTORY RIGHTS WHICH YOU MAY BE ENTITLED TO AS A CONSUMER AND THAT YOU CANNOT CONTRACTUALLY AGREE TO ALTER OR WAIVE. THE LIMITATIONS AND EXCLUSIONS OF LIABILITY DO NOT APPLY IF AND TO THE EXTENT YOU SUSTAIN DAMAGES WHICH WERE CAUSED BY GROSS NEGLIGENCE OR WILLFUL MISCONDUCT OF EPIC."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "UNDER NO CIRCUMSTANCES INCLUDING NEGLIGENCE (UNLESS OTHERWISE REQUIRED BY APPLICABLE LAW), SHALL EPIC BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES THAT RESULT FROM YOUR USE OF MEGASCANS OR RELATED DOCUMENTATION OR IN CONNECTION WITH OR ARISING OUT OF OR RELATING TO THIS AGREEMENT (INCLUDING LOSS OF BUSINESS, REVENUE, PROFITS, USE, DATA, OR OTHER ECONOMIC ADVANTAGE), EVEN IF ANY EXCLUSIVE REMEDY PROVIDED FOR IN THIS AGREEMENT FAILS OF ITS ESSENTIAL PURPOSE AND EVEN IF EPIC OR A EPIC AUTHORIZED REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANY DAMAGES THAT YOU MIGHT INCUR FOR ANY REASON WHATSOEVER (INCLUDING, WITHOUT LIMITATION, ALL DAMAGES REFERENCED HEREIN AND ALL DIRECT OR GENERAL DAMAGES IN CONTRACT OR ANYTHING ELSE), THE ENTIRE LIABILITY OF EPIC AND ANY OF ITS SUPPLIERS UNDER ANY PROVISION OF THIS EULA AND YOUR EXCLUSIVE REMEDY HEREUNDER SHALL BE LIMITED TO THE ACTUAL DAMAGES YOU INCUR IN REASONABLE RELIANCE ON EPIC UP TO THE AMOUNT ACTUALLY PAID BY YOU FOR THE SERVICES IN THE 12 MONTHS IMMEDIATELY PRECEDING THE FIRST EVENTS GIVING RISE TO SUCH LIABILITY. THE FOREGOING LIMITATIONS, EXCLUSIONS, AND DISCLAIMERS SHALL APPLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, EVEN IF ANY REMEDY FAILS ITS ESSENTIAL PURPOSE. EPIC SHALL HAVE NO LIABILITY TO YOU IN THE EVENT THAT YOU HAVE FAILED TO COMPLY WITH THE TERMS OF THIS AGREEMENT."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "10. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "INDEMNIFICATION"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "You agree to defend, indemnify, and hold harmless Epic, its parents and affiliates, partners, and their respective employees, contractors, officers, and directors, from and against any actions, claims, demands, liability and expenses, including reasonable attorneys\u2019 fees, arising out of Your use or misuse of the Services, the Licensed Assets, or the rights granted under this Agreement. You agree that Epic may seek and shall be entitled to injunctive, equitable, or other similar relief to protect, maintain, defend, enforce, and preserve its rights, in addition to any other available remedies without the necessity of posting a bond."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "11. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "GOVERNING LAW"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "You agree that this Agreement will be deemed to have been made and executed in the State of North Carolina, U.S.A., and any dispute will be resolved in accordance with the laws of North Carolina, excluding that body of law related to choice of laws, and of the United States of America.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "Any action or proceeding brought to enforce the terms of this Agreement or to adjudicate any dispute must be brought in the Superior Court of Wake County, State of North Carolina or the United States District Court for the Eastern District of North Carolina.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "You agree to the exclusive jurisdiction and venue of these courts.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "You waive any claim of inconvenient forum and any right to a jury trial.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "The Convention on Contracts for the International Sale of Goods will not apply.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "Any law or regulation which provides that the language of a contract shall be construed against the drafter will not apply to this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "MISCELLANEOUS"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.1 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Modification"
                ),
                ". Epic reserves the right, at its discretion, to update or revise the EULA at any time. Epic will post such changes in the Services, and/or its Website, and/or communicate such changes via electronic mail or otherwise communicate such terms to You in a suitable manner decided by Epic and these additional or revised terms will become part of the EULA effective immediately. Please check the Services, the EULA or the Website periodically for changes. Your continued use of the Services constitutes Your binding acceptance of the EULA, including any changes or modifications made by Epic as permitted above."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.2 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Waiver"
                ),
                ". A provision of this Agreement may be waived only by a written instrument executed by the party entitled to the benefit of such provision. The failure of any party at any time to require performance of any provision of this Agreement shall in no manner affect such party\u2019s right at a later time to enforce the same. A waiver of any breach of any provision of this Agreement shall not be construed as a continuing waiver of other breaches of the same or other provisions of this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.3 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Severability"
                ),
                ". If any provision of this Agreement shall be unlawful, void, or for any reason unenforceable, then that provision shall be deemed severable from this Agreement and shall not affect the validity and enforceability of any remaining provisions which shall continue in full force and effect."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.4 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Assignment"
                ),
                ". You shall not, without the prior written consent of Epic, assign, transfer, charge, sub-contract, license or deal in any other manner with all or any of Your rights or obligations under this EULA. Epic may at any time assign, transfer, charge, sub- contract or deal in any other manner with all or any of its rights or obligations under this EULA without notice to You."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.5 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "No Partnership"
                ),
                ". This Agreement does not constitute and shall not be construed as constituting a partnership or joint venture between Epic and You. Neither party hereto shall have any right to obligate or bind the other party in any manner whatsoever, and nothing herein contained shall give, or is intended to give, any rights of any kind to any third persons."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.6 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Credits in The Products"
                ),
                ". You shall use best efforts to include the Quixel logo and credits in the Product, PR materials etc, for example: \"Uses Megascans (TM), Copyright (c) \u2013 2019 Epic Games, Inc.\". Current versions of Quixel\u2019s logotype, credit terms etc. can be found at",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "https://cdn.quixel.com/megascans/presskit/Megascans_Press_Kit.zip"
                  },
                  "https://cdn.quixel.com/megascans/presskit/Megascans_Press_Kit.zip"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "12.7 ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Entire Agreement"
                ),
                ". This EULA constitutes the entire agreement between the parties with respect to this specific subject matter hereof and shall not be modified except as provided in this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "13. ",
                _react2.default.createElement(
                  "strong",
                  null,
                  "DEFINITIONS"
                ),
                "."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "As used in this Agreement, the following capitalized words have the following meanings:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Agreement"
                ),
                "\u201D or \u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "EULA"
                ),
                "\u201D shall have the meaning set forth in the preamble."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Bridge"
                ),
                "\u201D shall have the meaning set forth in Section 3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Customer Assets"
                ),
                "\u201D shall have the meaning set forth in Section 3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Epic"
                ),
                "\u201D means, depending on the location of your primary residence or primary place of business:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "a. Epic Games, Inc., a Maryland Corporation having its principal business offices at Box 254, 2474 Walnut Street, Cary, North Carolina, 27518, U.S.A.; or"
              ),
              _react2.default.createElement(
                "p",
                { className: "p5" },
                "b. Epic Games International S.\xE0 r.l., a Luxembourg Soci\xE9t\xE9 \xE0 Responsibilit\xE9 Limit\xE9e, located at Atrium Business Park, 33 rue du Puits Romain, L8070 Bertrange, Grand-Duchy of Luxembourg, acting through its Swiss branch, having its principal business offices at Platz 3,",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                "6039 Root, Switzerland."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Feedback"
                ),
                "\u201D shall have the meaning set forth in Section 10."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Fees"
                ),
                "\u201D shall have the meaning set forth in Section 5."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Licensed Assets"
                ),
                "\u201D means Customer Assets and Megascans Assets."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Megascans Assets"
                ),
                "\u201D shall have the meaning set forth in Section 3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Megascans Free Assets"
                ),
                "\u201D means the free assets from the Quixel Megascans library made available by Epic to You under this Agreement via the Services."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Mixer"
                ),
                "\u201D shall have the meaning set forth in Section 3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Points"
                ),
                "\u201D shall have the meaning set forth in Section 5."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Products"
                ),
                "\u201D shall mean any product or service that incorporates Licensed Assets under this Agreement."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Registered User"
                ),
                "\u201D shall have the meaning set forth in Section 2."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Services"
                ),
                "\u201D shall have the meaning set forth in Section 3."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Start Date"
                ),
                "\u201D shall have the meaning set forth in Section 1."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Twinmotion"
                ),
                "\u201D means Epic\u2019s proprietary software application known as Twinmotion."
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "Twinmotion EULA"
                ),
                "\u201D means the Twinmotion End User License Agreement (as available at",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "https://unrealengine.com/twinmotion/eula"
                  },
                  "unrealengine.com/twinmotion/eula"
                ),
                ")"
              ),
              _react2.default.createElement(
                "p",
                { className: "p3" },
                "\u201C",
                _react2.default.createElement(
                  "strong",
                  null,
                  "You"
                ),
                "\u201D shall have the meaning set forth in the preamble."
              )
            ),
            _react2.default.createElement(
              "div",
              { className: _hr },
              _react2.default.createElement(_Hr2.default, null)
            )
          ),
          _react2.default.createElement(
            "section",
            { id: "privacy-policy", className: tos },
            _react2.default.createElement(_PageTitle2.default, {
              align: "left",
              dateTop: true,
              title: "PRIVACY POLICY",
              subTitle: "NOV 12TH 2019"
            }),
            _react2.default.createElement(
              "div",
              { className: content },
              _react2.default.createElement(
                "h1",
                { className: "p1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "Introduction"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Our Privacy Policy is designed to help you understand what personally identifiable information we collect, how we use it and what rights you have."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "For the purposes of applicable data protection legislation the relevant Epic entity identified for your region in the \u201CContact\u201D section of the policy below is the controller of personal data provided by you and determines how and why your personal data will be processed."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Please note that this Privacy Policy applies to the following internet sites:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                _react2.default.createElement(
                  _Link2.default,
                  { href: "/", className: _link },
                  "www.quixel.com"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Should you have any questions about our processing of personal data or about this Privacy Policy, please refer to the last section on how to get in touch."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "When we talk about the\xA0",
                _react2.default.createElement(
                  "strong",
                  null,
                  "\u201CServices\u201D"
                ),
                "\xA0in this policy, we are referring to our websites, softwares and copyright assets and other services which we have licensed to our Customers. When we talk about\xA0",
                _react2.default.createElement(
                  "strong",
                  null,
                  "\u201CPersonal Data\u201D"
                ),
                "\xA0in this policy, we are referring to personally identifiable information you provide when using our Services or in any other contact with us, except for any anonymised Personal Data. When we talk about\xA0",
                _react2.default.createElement(
                  "strong",
                  null,
                  "\u201CAffiliated Parties\u201D"
                ),
                "\xA0in this policy, we are referring to our partners, affiliated companies and third parties."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "PLEASE READ THIS PRIVACY POLICY BEFORE USING OUR SERVICES. IF YOU DO NOT AGREE WITH THIS PRIVACY POLICY, PLEASE DO NOT USE THE SERVICES."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "1. What Personal Data we collect?"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We collect and process the following types of personal data about you:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Identification Data"
                    ),
                    "\xA0such as your name, street address, postal code, city, country, email address and project name."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Contact Data"
                    ),
                    "\xA0such as your billing address, and email address."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Financial Data"
                    ),
                    "\xA0such as your payment card details."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Transaction Data"
                    ),
                    "\xA0such as details about payments between you and us and other details of purchases made by you."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Technical Data"
                    ),
                    "\xA0such as your login data, internet protocol addresses, browser type and version, operating system and platform and other technology on the devices you use to access our Services."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Profile Data"
                    ),
                    "\xA0such as your username and password, purchases or orders, your interests, preferences, feedback and survey responses."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Usage Data"
                    ),
                    "\xA0such as information about how you use our website, products and Services."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Marketing and Communications Data"
                    ),
                    "\xA0such as your preferences in receiving marketing communications from us and your communication preferences."
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We do not collect any Sensitive Data about you. Sensitive data refers to data that includes details about your race or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade union membership, information about your health and genetic and biometric data. We do not collect any information about criminal convictions and offences."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We only collect Personal Data that it deems to be reasonably necessary to fulfill your online requests and our legitimate business objectives."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "2. How we collect your Personal Data?"
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "li",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "Direct interactions:\xA0"
                  ),
                  "You may provide data by filling in forms on our site (or otherwise) or by communicating with us by email or otherwise, including when you:"
                ),
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Order our products or Services;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Create an account on any of our sites;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Subscribe to our Services or publications;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Request resources or marketing be sent to you;"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Enter a competition, prize draw, promotion or survey; or"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Give us feedback."
                  )
                ),
                _react2.default.createElement(
                  "li",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "Automated technologies or interactions:\xA0"
                  ),
                  "As you use our Services, we may automatically collect Technical Data about your equipment, browsing actions and usage patterns. We collect this data by using cookies, server logs and Google Analytics. Please see our cookie policy at\xA0",
                  _react2.default.createElement(
                    _Link2.default,
                    { href: "/cookiepolicy", className: _link },
                    "Cookie policy"
                  ),
                  "\xA0for further details."
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "3. How and why we use your Personal Data?"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Set out below is a description of the ways we intend to use your personal data and the legal grounds on which we will process such data. We have also explained what our legitimate interests are where relevant. The Type of Data in the chart below refers to the definitions described under section 1."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "The most common legal/lawful grounds of our processing of your personal data are:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Where we need to perform the contract between us."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Where we need to comply with a legal or regulatory obligation."
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may process your personal data for more than one lawful ground, depending on the specific purpose for which we are using your data. Please email us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                "\xA0if you need details about the specific legal ground we are relying on to process your personal data where more than one ground has been set out in the table below."
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "div",
                  {
                    className: (0, _glamor.css)({
                      fontSize: (0, _css.unitRem)(0.875),
                      width: "126%",
                      marginLeft: "-16%",
                      display: "flex",
                      flexWrap: "wrap",
                      color: "" + _css.pallets.gray_text
                    }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
                      fontSize: (0, _css.unitRem)(0.7),
                      marginLeft: "-12%"
                    }))
                  },
                  _react2.default.createElement(
                    "div",
                    { className: heading },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "strong",
                        null,
                        "Purpose/Activity"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: heading },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "strong",
                        null,
                        "Type of Data"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: heading },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "strong",
                        null,
                        "Lawful Basis for Processing"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To register you as a new customer"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "ul",
                      null,
                      _react2.default.createElement(
                        "li",
                        null,
                        "Identification Data"
                      ),
                      _react2.default.createElement(
                        "li",
                        null,
                        "Contact Data"
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Performance of a contract with you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To process your order including:",
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Manage payments, fees and charges"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Financial Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Transaction Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Performance of a contract with you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To manage our business relationship with you which will include:",
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Notifying you about changes to our terms or privacy policy"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Asking you to leave a review or take a survey"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "To send you product and company updates"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Profile Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Marketing and Communications Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Performance of a contract with you"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Necessary to comply with a legal obligation, i.e. due to product liability, data protection legislation or accounting legislation."
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Necessary for our legitimate interests to keep our records updated and to study how customers use our products/services"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To enable you to partake in a prize draw, competition or complete a survey"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Profile Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Usage Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Marketing and Communications Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Performance of a contract with you"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Necessary for our legitimate interests to study how customers use our products/services, to develop them and grow our business",
                          " "
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Based on consent from you"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To administer and protect our business and our Services (including troubleshooting, testing, system maintenance, support, reporting and hosting of data)"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Technical Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Performance of a contract with you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To use data analytics to improve or develop our website, products/Services, marketing, customer relationships and experiences"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Technical Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Usage Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Necessary for our legitimate interests to define types of customers for our products and Services, to keep our site updated and relevant, to develop our business and to inform our marketing strategy"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "To make suggestions and recommendations to you about our different goods or services that may be of interest to you"
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      _react2.default.createElement(
                        "ul",
                        null,
                        _react2.default.createElement(
                          "li",
                          null,
                          "Identification Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Contact Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Technical Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Usage Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Profile Data"
                        ),
                        _react2.default.createElement(
                          "li",
                          null,
                          "Marketing and Communications Data"
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: _col },
                    _react2.default.createElement(
                      "p",
                      null,
                      "Necessary for our legitimate interests to develop our products/services and grow our business"
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "ul",
                null,
                _react2.default.createElement(
                  "li",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "Marketing communications"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You will receive marketing communications from us if you have:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "ul",
                    { className: "ul1" },
                    _react2.default.createElement(
                      "li",
                      { className: "li1" },
                      "Requested information from us or purchased goods or Services from us; or"
                    ),
                    _react2.default.createElement(
                      "li",
                      { className: "li1" },
                      "If you provided us with your details and ticked the box at the point of entry of your details for us to send you marketing communications, e.g. when you purchased goods or Services, or when you registered for subscription; and"
                    ),
                    _react2.default.createElement(
                      "li",
                      { className: "li1" },
                      "In each case, you have not opted out of receiving that marketing."
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We will get your express opt-in consent before we share your personal data with any third party for their or other third party marketing purposes. Generally, we do not rely on consent as a legal ground for processing your personal data, other than in relation to sending marketing communications to you via email."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You have the right to withdraw consent to marketing at any time. You can ask us to stop sending you marketing messages by following the opt-out links on any marketing message sent to you or by emailing us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Where you opt out of receiving our marketing communications, this will not apply to personal data provided to us as a result of a product/Service purchase, product/Service experience or other transactions."
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Change of purpose"
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We will only use your personal data for the purposes for which we collected it, unless we reasonably consider that we need to use it for another reason and that reason is compatible with the original purpose. If you wish to find out more about how the processing for the new purpose is compatible with the original purpose, please email us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If we need to use your personal data for a purpose unrelated to the purpose for which we collected the data, we will notify you and we will explain the legal ground of processing."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may process your personal data without your knowledge or consent where this is required or permitted by law."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "4. Cookies and Logs"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "A cookie is information a website places on your computer\u2019s hard drive so that the website is able to remember your preferences and/or which pages you visited on the website and make your visit more efficient and enjoyable."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Wel may use cookies to determine the number of unique visitors to our Service over a given period, or to remember user account details, etc. so that the need for multiple log-ins is eliminated. We may combine information collected through cookies to any personal information submitted online when using the Service to help personalize your access to and use of the Service. Cookies may be disabled on your computer by indicating this in the preferences or options menus in your browser."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may collect data in the form of logs. Log data collected on web servers supplies us with aggregate information about the number of visits to different pages on the Service and other navigational data. The variety of technical information we may log is:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "IP address"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Device information, including device name and IDs, hardware model, operating system and version, and mobile network information"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Browser information"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Cookie information"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Date/time of access"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Requested page(s)"
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Referring page(s)"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "For details you can take a look at our",
                " ",
                _react2.default.createElement(
                  _Link2.default,
                  { href: "/cookiepolicy", className: _link },
                  "Cookie Policy"
                ),
                "\xA0here."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "5. Your Rights on the Collection, Use and Distribution of Personal Data"
                )
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "p",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "5.1 Opt In/Opt Out"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We allow you to monitor the way in which we use the personal information we obtain. Any promotional materials which We may send to you (e.g. \"newsletters\" or \"information bulletins\") contain internal mechanisms that allow you to block future mailings (Opt-out)."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We also allow you to control if you want to share app usage data related to our Mixer and Bridge apps. These apps have built in mechanisms that allow you to opt out of sharing this information with us."
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "p",
                  { className: "li1" },
                  _react2.default.createElement(
                    "strong",
                    null,
                    "5.2 Right to Access, Rectify, Modify, Erase and Object"
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You have the right to request access, rectification, or erasure of your data that we have collected."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You also have the right to object or restrict, for legitimate purposes, the processing of your Personal Data, as well as the right to data portability. In case of restriction we may not be able to provide certain Services to you."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You may also withdraw your consent on receiving marketing communications and on sharing your data with us."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "End Users who wish to deactivate their account may do so in accordance with the terms in the EULA (End User License Agreement). Removed information may persist in backup copies for a reasonable period of time but will not be generally available to other End Users of the Software."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Removed information is retained for our own internal accounting purposes along with furnishing customer requests for old invoices."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "You will not have to pay a fee to access your personal data (or to exercise any of the other rights). However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive. Alternatively, we may refuse to comply with your request in these circumstances."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may need to request specific information from you to help us confirm your identity and ensure your right to access your personal data (or to exercise any of your other rights). This is a security measure to ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact you to ask you for further information in relation to your request to speed up our response."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We try to respond to all legitimate requests within one month. Occasionally it may take us longer than a month if your request is particularly complex or you have made a number of requests. In this case, we will notify you and keep you updated."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If you wish to exercise any of the rights set out above, please email us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                ". Furthermore, you have a right to lodge a complaint regarding our processing of your data with the supervisory authority in the EU member state of your residence, place of work or place of the alleged infringement."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "6. Data Retention."
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "To determine the appropriate retention period for personal data, we consider the amount, nature, and sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your personal data, the purposes for which we process your personal data and whether we can achieve those purposes through other means, and the applicable legal requirements."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "By law we have to keep basic information about our customers (including Contact, Identity, Financial and Transaction Data) for seven years after they cease being customers for accounting and tax purposes."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "In some circumstances we may anonymise your personal data (so that it can no longer be associated with you) for research or statistical purposes in which case we may use this information indefinitely without further notice to you."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "7. Sharing and Disclosure of Personal Data."
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We do not sell your data to any third party for marketing purposes. As a general rule, we will not forward your Personal Data to third parties without your permission. However, since we work in conjunction with partners, affiliated companies and third parties for the provisioning of our Services, we may have to share your personal data with them."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may also disclose or share your data with:"
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Service providers who provide IT and system administration services."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Subsidiaries or other group companies."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Affiliated Parties."
                  ),
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    "Professional advisers including lawyers, bankers, auditors and insurers who provide consultancy, banking, legal, insurance and accounting services."
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We only allow such third parties to process your personal data for specified purposes and in accordance with our instructions and applicable data protection law."
              ),
              _react2.default.createElement(
                "ul",
                { className: "ul1" },
                _react2.default.createElement(
                  "ul",
                  { className: "ul1" },
                  _react2.default.createElement(
                    "li",
                    { className: "li1" },
                    _react2.default.createElement(
                      "strong",
                      null,
                      "Legally Compelled Disclosures"
                    )
                  )
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We may disclose your Personal Data if required to do so by law or if we believe that such action is necessary to (a) conform to the law, comply with a judicial or court order or comply with legal process served on us or Affiliated Parties; (b) protect and defend our rights and property, the services, the users of the services, and/or our Affiliated Parties; or (c) act under circumstances to protect the safety of users of our services, us, or third parties."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "8. International Data Transfers"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We are based in Sweden, and your Personal Data is collected and processed in accordance with Swedish privacy laws and EU General Data Protection Regulation."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We strive to process all your data inside the EU/EEA (European Union/European Economic Area). However, we may share, store and process your information with our affiliates or third parties, out of which some may be located in countries outside the EU/EEA, such as the United States and any other country in which we maintain our facilities. When personal data is shared or transferred under these circumstances, we will ensure that the transfer will be subject to appropriate safeguards in accordance with applicable data protection legislation and that the level of protection is equivalent to that applicable in the EU/EEA."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "9. Security"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We have taken steps to ensure that the Personal Data we collect is secure. We have also taken a range of technical and organizational measures to protect the confidentiality, security, and integrity of the Personal Data collected from you including protecting your data from unauthorized access, loss, change or deletion. Personal Data is stored in secure operating environments that are not available to the public and that are only accessible to authorized employees, consultants and/or service providers."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We also have security measures in place to protect the loss, misuse, and alteration of the information under our control. Such actions include, but are not limited to, physical controls, encryption, eligibility restrictions, policies, etc."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "10. Privacy of Minors"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Our Services are not meant to be used by anyone under the age of 13. We do not knowingly collect Personal Data such as name and email address from children under 13 years old in the Service, unless expressly permitted by parent or guardian. We believe it is important to safeguard the privacy of children and encourage parents to regularly take an interest in their children\u2019s use of online activities. If you are a parent and believe that your child under the age of 13 has used the Service and provided Personal Data to us, please contact us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                "\xA0and we will delete your child\u2019s account and any related Personal Data."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "11. Governing Law"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "For Megascans, any dispute, controversy or claim arising out of or in connection with this Privacy Policy, or the breach, termination or invalidity thereof, shall be governed by the laws and venue as stated in sections 28-30 of the End User License Agreement\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  { className: _link, href: "/terms" },
                  "https://quixel.com/terms"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "12. Changes to our Privacy Policy"
                )
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "This Privacy Policy may be subject to change from time to time. If substantial changes are made to the Privacy Policy, we will notify you of these material changes by posting them on the Service and/or informing you by e-mail sent to the address provided by you to us, or if possible in some other manner. You are encouraged to check back and review this Privacy Policy from time to time so that you will always know what information is collected, how it is used and to whom it is disclosed. Your continued use of the Service subject to this Privacy Policy will signify your acceptance of Privacy Policy changes."
              ),
              _react2.default.createElement(
                "p",
                { className: "li1" },
                _react2.default.createElement(
                  "strong",
                  null,
                  "13. Contact."
                ),
                "\xA0 If you have any questions about this Policy, please contact us at\xA0",
                _react2.default.createElement(
                  _Link2.default,
                  {
                    className: _link,
                    target: "_blank",
                    href: "mailto:legal@quixel.se"
                  },
                  "legal@quixel.se"
                ),
                "\xA0or"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If you reside in the United States of America at:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Epic Games, Inc., located at located at 620 Crossroads Blvd., Cary, NC 27518, USA."
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "If you reside outside of the United States of America at:"
              ),
              _react2.default.createElement(
                "p",
                { className: "p1" },
                "Epic Games International S.\xE0 r.l., a Luxembourg Soci\xE9t\xE9 \xE0 Responsibilit\xE9 Limit\xE9e, located at Atrium Business Park, 33 rue du Puits Romain, L8070 Bertrange, Grand-Duchy of Luxembourg, acting through its Swiss branch, having its principal business offices at Platz 3, 6039 Root, Switzerland.",
                _react2.default.createElement(
                  "span",
                  { className: "Apple-converted-space" },
                  "\xA0 "
                ),
                _react2.default.createElement("br", null),
                " ",
                _react2.default.createElement("br", null),
                " ",
                _react2.default.createElement("br", null)
              )
            ),
            _react2.default.createElement(
              "div",
              { className: _hr },
              _react2.default.createElement(_Hr2.default, null)
            )
          )
        )
      );
    }
  }]);
  return ToS;
}(_react.Component), _class.contextTypes = {
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = ToS;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ToS/ToS.jsx
// module id = 2729
// module chunks = 0